// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamActions_wrapper_u_sGp"};